import { render, staticRenderFns } from "./MapaProventos.vue?vue&type=template&id=64c267d3&scoped=true"
import script from "./MapaProventos.vue?vue&type=script&lang=js"
export * from "./MapaProventos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c267d3",
  null
  
)

export default component.exports